module.exports = "<covance-tooltip>\r\n    <div result-content>{{value}}</div>\r\n    <div tooltip-content>{{value}}</div>\r\n</covance-tooltip>"